import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import { checkVersionAndReload } from '../../utils/version';

const VERSION_CHECK_INTERVAL = process.env.REACT_APP_VERSION_CHECK_INTERVAL ? parseInt(process.env.REACT_APP_VERSION_CHECK_INTERVAL) : 600000; // 10분 (600초)

export const VersionChecker = () => {
    const location = useLocation();
    const intervalRef = useRef(null);

    useEffect(() => {
        // 버전 체크 시작
        // 앱 타입이 commander이고 웹뷰가 있는 경우에만 버전 체크를 수행
        // 또한 production 또는 staging 환경에서만 동작하도록 함
        const appType = localStorage.getItem('appType');
        if (appType && appType === 'commander' && window.ReactNativeWebView &&
            (process.env.REACT_APP_MODE === 'production' || process.env.REACT_APP_MODE === 'staging')) {
            startVersionCheck();
        }

        // 컴포넌트 언마운트 시 정리
        return () => {
            stopVersionCheck();
        };
    }, []);

    useEffect(() => {
        // 페이지 이동 시 버전 체크 수행
        // admin 또는 commander 앱 타입이고 production/staging 환경일 때만 실행
        const appType = localStorage.getItem('appType');
        if ((appType && (appType === 'admin' || appType === 'commander')) &&
            (process.env.REACT_APP_MODE === 'production' || process.env.REACT_APP_MODE === 'staging')) {
            checkVersionAndReload();
        }
    }, [location.pathname]);

    // 버전 체크 시작
    const startVersionCheck = () => {
        // 실행 중이면 중지
        stopVersionCheck();
        
        // 즉시 한 번 체크
        checkVersionAndReload();

        // 주기적으로 체크
        intervalRef.current = setInterval(() => {
            checkVersionAndReload();
        }, VERSION_CHECK_INTERVAL);
        
        //console.log('VersionChecker: 버전 체크 시작됨');
    };

    // 버전 체크 중지
    const stopVersionCheck = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            //console.log('VersionChecker: 버전 체크 중지됨');
        }
    };

    return null;
};